export type TrackedElement = {
  attributeCamelName: string
  attributeKebabName: string
}

const VIDEO_PLACEHOLDER: TrackedElement = { attributeCamelName: 'rrwebVideoPlaceholderName', attributeKebabName: 'rrweb-video-placeholder-name' }
const VIDEO_MIRROR_PLACEHOLDER: TrackedElement = {
  attributeCamelName: 'rrwebVideoMirrorPlaceholderName',
  attributeKebabName: 'rrweb-video-mirror-placeholder-name'
}

export const TrackedElementDetails = {
  VIDEO_PLACEHOLDER,
  VIDEO_MIRROR_PLACEHOLDER
} as const
